module.exports = __webpack_public_path__ + "img/sponsorA22.d2fdc66c.png";